import React, {FC, useEffect, useState} from 'react'
import {getGeneralStatus} from './Api'
import {IGeneralStatusModel} from './DashboardModel'

interface StatItem {
  label: string
  value: number
}

interface StatCard {
  title?: string
  items: StatItem[]
}

const GeneralStatusPanel: FC = () => {
  const [data, setData] = useState<IGeneralStatusModel | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getGeneralStatus()
      .then((res: any) => {
        const payload = res.data?.payload ?? res.payload ?? null
        setData(payload)
      })
      .catch((err) => console.error('Genel durum yüklenemedi:', err))
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div className='text-center py-10'>
        <span className='spinner-border spinner-border-sm me-2' />
        Yükleniyor...
      </div>
    )
  }

  if (!data) return null

  const columns: StatCard[] = [
    {
      items: [
        {label: 'Kiradakiler', value: data.rentedCount},
        {label: 'Bugün Çıkanlar', value: data.todayDepartures},
        {label: 'Bugün Dönenler', value: data.todayReturns},
        {label: 'Bugün Dönüşü Beklenenler', value: data.todayExpectedReturns},
        {label: 'Yarın Dönüşü Beklenenler', value: data.tomorrowExpectedReturns},
        {label: 'Dönüşü Gecikenler', value: data.lateReturns},
        {label: 'Suistimal (+3 gün geçmiş)', value: data.abuse},
      ],
    },
    {
      items: [
        {label: 'Gelecek Rezervasyonlar', value: data.futureReservations},
        {label: 'Bugün Çıkışı Beklenen', value: data.todayExpectedDepartures},
        {label: 'Yarın Çıkışı Beklenen', value: data.tomorrowExpectedDepartures},
        {label: 'Bugünkü İptaller', value: data.todayCancellations},
        {label: 'Sözleşmede (Bugün)', value: data.inContractToday},
        {label: 'Plakasız Rezervasyonlar', value: data.noPlateReservations},
      ],
    },
    {
      items: [
        {label: 'Webe Kapalı Araçlar', value: data.webClosedCars},
        {label: 'Ofis Rez.e Kapalı Araçlar', value: data.officeReservationClosedCars},
        {label: 'Muayenesi Gelenler', value: data.inspectionDue},
        {label: 'Sigortası Gelenler', value: data.insuranceDue},
        {label: 'Kaskosu Gelenler', value: data.cascoDue},
        {label: "BAF'daki Araçlar", value: data.bafCars},
        {label: 'Zamanaşımı', value: data.agingCars},
        {label: 'Bugün Bitecek', value: data.endingToday},
      ],
    },
    {
      title: 'Servis İşlemleri',
      items: [
        {label: 'Servis İşlemleri', value: data.serviceOperations},
        {label: 'Bekleyen Talepler', value: data.pendingRequests},
        {label: 'Servise Teslim Et', value: data.deliverToService},
        {label: 'Servisten Al', value: data.pickFromService},
        {label: 'Zamanaşımı', value: data.serviceAging},
      ],
    },
  ]

  return (
    <div className='row g-5 g-xl-8'>
      {columns.map((col, colIdx) => (
        <div key={colIdx} className='col-xl-3'>
          <div className='card shadow-sm h-100'>
            <div className='card-body p-0'>
              <table className='table table-row-bordered table-row-gray-200 align-middle mb-0'>
                <tbody>
                  {col.items.map((item, idx) => {
                    const isHeader = idx === 0 && col.title
                    return (
                      <tr key={idx}>
                        <td className='ps-5 py-3 text-gray-800 fw-semibold fs-7'>
                          {item.label}
                          {isHeader && (
                            <i
                              className='bi bi-question-circle ms-2 text-gray-400'
                              title='Servis İşlemleri'
                            />
                          )}
                        </td>
                        <td className='pe-5 py-3 text-end' style={{width: '60px'}}>
                          <span
                            className='fw-bold fs-6'
                            style={{color: '#7239ea'}}
                          >
                            {item.value}
                          </span>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default GeneralStatusPanel
